<template>
  <div class="container_box">
    <!--配置信息展示区域-->
    <div class="config_box">
      <Icon size="21" color="#71B4FA" type="ios-information-circle"/>
      <p class="ml12 mr50">{{ $t('key1003585') }}</p>
      <p>{{ $t('key1003586') }}</p>
      <Badge :status="taskStatus" :text="taskStatusText"/>
      <Button v-if="taskStatus === 'processing' && getPermission('productInfo_stopPriceAutoRule')"
        type="error" size="small" class="ml15" @click="stopTheTaskBtn">{{ $t('key1003587') }}</Button>
      <p class="ml50">{{ $t('key1003584') + lastSuccessDate }}</p>
      <Button type="primary" size="small" class="modify_styles ml50" v-if="getPermission('productInfo_startPriceAutoRule')"
        :disabled="taskStatus === 'processing'" @click="ruleEnforcementBtn">
        <Tooltip placement="top" max-width="500" transfer
          :content="$t('key1003581')">
          <Icon size="19" class="help_icon" type="ios-information-circle"/>
        </Tooltip>
        <p>{{ $t('key1003588') }}</p>
      </Button>
    </div>
    <!--Tab栏区域-->
    <Tabs v-model="configStatus" :animated="false" class="tabs_styles" @on-click="changeConfigTab">
      <TabPane v-for="item in configList" :label="item.title" :name="item.value.toString()"></TabPane>
    </Tabs>
    <div class="flex">
      <Tabs type="card" v-model="configValue" :animated="false" @on-click="changeConfigValue">
        <TabPane v-for="item in configValueList" :label="item.title" :name="item.name"></TabPane>
      </Tabs>
      <p class="font-size-14 ml20 pt7">{{ configValueText }}</p>
    </div>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParam" :model="pageParam" :label-width="100" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001437')" prop="name">
              <Input v-model.trim="pageParam.name" :placeholder="$t('key1002165')"></Input>
            </FormItem>
          </Col>
          <Col :xxl="threeItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1003582')" prop="searchValue">
              <Input v-model.trim="pageParam.searchValue" :placeholder="$t('key1003583')"></Input>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001522')" :label-width="130">
              <local-tabButton :tabButtonList="statusList" @selectStatus="selectStatus"></local-tabButton>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button class="mr15" type="primary" :disabled="taskStatus === 'processing'"
        v-if="getPermission('ymsProductPriceRule_insert') || getPermission('ymsProductPriceServiceRule_insert')"
        @click="addRuleConfigBtn('add')">{{ ruleConfigText }}
      </Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="600"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        :draggable="tableData.length >1 && taskStatus !== 'processing'"
        @on-drag-drop="dragDrop">
      </Table>
    </div>
    <!--查看、编辑仓库规则弹窗-->
    <ruleTemp
      ref="ruleTemp"
      :showProductWholesaleModel="showProductWholesaleModel"
      :ruleType="ruleType"
      @updateData="search">
    </ruleTemp>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {
  getUserNameByUserId, getAllGoodsWarehouse, getDeliveryAreasAllData,
  getCustomerLevelAll, toPercent, amountHandel, commonCopyContent, _handleMultilingualFields, getAllUsersInfo, getCloudTreeData, commonLocalStorage
} from "@/utils/common";
import ruleTemp from "@/components/common/ruleTemp.vue";

export default {
  name: 'productSalesPriceConfig',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      ruleType: 'productSalesPriceConfigRules',
      configStatus: '1',
      pageParam: {
        name: '',
        searchValue: '',
        status: null,
      },
      configList: [
        {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003554')},
        {value: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003555')},
      ],
      configValue: 'commonConfig',
      configValueList: [
        {name: 'commonConfig', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003556')},
        {name: 'specialConfig', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003557')},
      ],
      statusList: [
        {selected: true, value: -1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {selected: false, value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462')},
        {selected: false, value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')}
      ],
      taskStatus: 'success', // success、error、processing
      webSocketListenerKey: '',
      tableColumns: [
        {
          title: 'No.',
          key: 'index',
          width: 65,
          align: 'center',
          type: 'index'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002152'),
          width: 140,
          key: 'priority',
          align: 'center',
          render(h, params) {
            let disabled = v.taskStatus === 'processing' ||
              !v.getPermission('ymsProductPriceRule_updatePriority') ||
              !v.getPermission('ymsProductPriceServiceRule_updatePriority');
            let arr = [
              h('span', {
                attrs: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002153')},
                domProps: {innerHTML: '&#xe68a;'},
                class: ['icon', 'iconfont', disabled ? 'cursor-not-allowed' : 'cursor', 'greenColor'],
                style: {
                  fontSize: '18px',
                  margin: '0 4px'
                },
                on: {
                  click: () => {
                    if (!disabled) {
                      v.tableSort(params.row.autoRuleId, v.tableData.length - 1, params.index);
                    }
                  }
                }
              }),
              h('span', {
                attrs: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002154')},
                domProps: {innerHTML: '&#xe687;'},
                class: ['icon', 'iconfont', disabled ? 'cursor-not-allowed' : 'cursor', 'blueColor'],
                style: {
                  fontSize: '18px',
                  margin: '0 4px'
                },
                on: {
                  click: () => {
                    if (!disabled) {
                      v.tableSort(params.row.autoRuleId, 0, params.index);
                    }
                  }
                }
              }),
              h('Icon', {
                props: {type: 'md-move', size: 20},
                attrs: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002155')},
                style: {
                  marginLeft: '5px',
                  position: 'relative',
                  top: '-2px'
                },
                class: [disabled ? 'cursor-not-allowed' : 'cursor-move', 'grayColor']
              })
            ];
            if (params.index === 0) {
              arr.splice(1, 1);
            } else if (params.index === v.tableData.length - 1) {
              arr.splice(0, 1);
            }
            if (v.tableData.length > 1) {
              return h('div', {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }
              }, arr);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002156'),
          key: 'name',
          align: 'center',
          minWidth: 180,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003558'),
          key: 'productMarkupConfigurationRules',
          align: 'center',
          minWidth: 450,
          renderHeader: (h, params) => {
            let title = v.configStatus === '1' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003558') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003559');
            return h('span', title);
          },
          render: (h, params) => {
            let html = v.processConfigurationRuleContent(params.row);
            return h('div', {
              domProps: {
                innerHTML: html  // 渲染 HTML
              },
              class: 'flex flex-direction align-items-start mt4 mb4',
              on: {
                click: (e) => v.handleInnerHtmlCopy(e)
              }
            })
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            return params.row.status === 0 ? h('span', {
              class: 'redColor'
            }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')) : h('span', {
              class: 'greenColor'
            }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003560'),
          minWidth: 120,
          align: 'center',
          key: 'updatedBy',
          render: (h, params) => {
            return h('span', getUserNameByUserId(params.row.updatedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002971'),
          minWidth: 200,
          align: 'center',
          key: 'updateTime',
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.updatedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'operate',
          align: 'center',
          width: 220,
          render: (h, params) => {
            let {autoRuleId, status} = params.row;
            let disabled = v.taskStatus === 'processing';
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002184'),
                    show: v.getPermission('ymsProductPriceRule_update') || v.getPermission('ymsProductPriceServiceRule_update'),
                    clickFn: () => {
                      let type = v.taskStatus === 'processing' ? 'look' : 'edit';
                      v.addRuleConfigBtn(type, params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    styles: {
                      cursor: disabled ? 'not-allowed' : 'pointer',
                      color: disabled ? '#ccc' : '#3cb034',
                    },
                    show: status === 0 && (v.getPermission('ymsProductPriceRule_enable') || v.getPermission('ymsProductPriceServiceRule_enable')),
                    clickFn: () => {
                      if (!disabled) {
                        v.enableDisableBtn(autoRuleId, 'enable');
                      }
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: status === 1 && (v.getPermission('ymsProductPriceRule_disable') || v.getPermission('ymsProductPriceServiceRule_disable')),
                    styles: {
                      cursor: disabled ? 'not-allowed' : 'pointer',
                      color: disabled ? '#ccc' : '#FF3300',
                    },
                    clickFn: () => {
                      if (!disabled) {
                        v.enableDisableBtn(autoRuleId, 'disable');
                      }
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: v.getPermission('ymsProductPriceRule_delete') || v.getPermission('ymsProductPriceServiceRule_delete'),
                    styles: {
                      cursor: disabled ? 'not-allowed' : 'pointer',
                      color: disabled ? '#ccc' : '#FF0000',
                    },
                    clickFn: () => {
                      if (!disabled) {
                        v.deleteRuleBtn(autoRuleId);
                      }
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      categoricalData: [], // 分类数据
      deliveryLocationData: [], // 发货地数据
      shippingWarehouseData: [], // 发货仓数据
      customerLevelData: [], // 客户等级数据
      ruleTaskProgress: 0,
      lastSuccessDate: '-',
      userInfoList: {}
    }
  },
  computed: {
    // 规则配置名称
    ruleConfigText() {
      switch (this.configValue) {
        case 'commonConfig':
          return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003561');
        case 'specialConfig':
          return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003562');
      }
    },
    // 任务状态文本
    taskStatusText() {
      let v = this;
      let taskStatusText = '';
      switch (v.taskStatus) {
        case 'success':
          taskStatusText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003563');
          break;
        case 'error':
          taskStatusText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003564');
          break;
        case 'processing':
          taskStatusText = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003541')}${v.ruleTaskProgress}）`;
          break;
      }
      return taskStatusText;
    },
    // 配置值文本
    configValueText() {
      switch (this.configStatus) {
        case '1':
          return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003565');
        case '2':
          return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003566');
      }
    },
    ymsRuleType() {
      const prefix = this.configStatus === '1' ? 'ymsProductPrice' : 'ymsProductPriceService';
      const suffix = this.configValue === 'commonConfig' ? 'CommonRule' : 'MerchantRule';
      return `${prefix}${suffix}`;
    },
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 批发模式
    showProductWholesaleModel() {
      const obj = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(obj?.productWholesaleModelSaas) === 1;
    }
  },
  created() {
    this.initWebSocket();
    this.getRuleTaskInfo();
    this.initFun();
  },
beforeDestroy() {
    this._isDestroyed = true;
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        await getAllUsersInfo().then((data) => {
          this.userInfoList = data;
        });
        await this.getList();
      })();
    },
    // 查询按钮
    search() {
      this.getList();
    },
    // 切换Tab栏
    changeConfigTab(value) {
      this.configValue = 'commonConfig';
      this.selectStatus(0, -1);
      this.$refs['pageParam'].resetFields();
      this.configStatus = value;
      this.getList();
    },
    // 配置值切换
    changeConfigValue(value) {
      this.selectStatus(0, -1);
      this.$refs['pageParam'].resetFields();
      this.configValue = value;
      this.getList();
    },
    // 重置按钮
    reset() {
      this.selectStatus(0, -1);
      this.$refs['pageParam'].resetFields();
      this.getList();
    },
    // 参数处理
    handleParameter() {
      let params = Object.assign({}, this.pageParam);
      params.ymsRuleType = this.ymsRuleType;
      return params;
    },
    // 列表查询
    getList() {
      let v = this;
      v.tableData = [];
      let url = '';
      let query = v.handleParameter();
      if (['ymsProductPriceCommonRule', 'ymsProductPriceMerchantRule'].includes(v.ymsRuleType)) {
        url = api.post_ymsProductPriceRule_query;
      } else {
        url = api.post_ymsProductPriceServiceRule_query;
      }
      if (v.getPermission('ymsProductPriceRule_query') || v.getPermission('ymsProductPriceServiceRule_query')) {
        v.tableLoading = true;
        v.axios.post(url, query).then(async (response) => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.tableData = data || [];
            // 自动提取 ruleCode 并调用相应接口
            const ruleCodes = v.extractRuleCodes(data);
            await v.handleRuleCodes(ruleCodes);
            v.$nextTick(() => {
              v.tableLoading = false;
            });
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 提取所有 ruleItems 的 ruleCode
    extractRuleCodes(data) {
      if (!Array.isArray(data)) return [];
      return data.reduce((acc, cur) => {
        const codes = (cur.ruleItems || []).map(item => item.ruleCode);
        return acc.concat(codes);
      }, []);
    },
    // 根据 ruleCode 调不同接口
    async handleRuleCodes(ruleCodes) {
      if (!ruleCodes || !ruleCodes.length) return;
      const ruleMap = {
        // 获取分类数据
        cloudTree: {
          codes: ['CORE-YPPCR-001', 'CORE-YPPMR-001', 'CORE-YPPSCR-001', 'CORE-YPPSMR-001'],
          fn: async () => {
            const data = await getCloudTreeData(api.post_ymsProductCategory_queryAll, 'original');
            this.categoricalData = data;
          }
        },
        // 获取发货地数据、发货仓数据
        warehouseAndDelivery: {
          codes: ['CORE-YPPCR-003', 'CORE-YPPMR-003', 'CORE-YPPSCR-003', 'CORE-YPPSMR-003'],
          fn: async () => {
            let [deliveryLocationData, shippingWarehouseData] = await Promise.all([getDeliveryAreasAllData(), getAllGoodsWarehouse()]);
            this.deliveryLocationData = deliveryLocationData;
            this.shippingWarehouseData = shippingWarehouseData;
          }
        },
        // 获取客户等级数据
        customerLevel: {
          codes: ['CORE-YPPMR-007', 'CORE-YPPSMR-007'],
          fn: async () => {
            const data = await getCustomerLevelAll();
            data.map((item) => {
              item.name = _handleMultilingualFields(item.name);
            })
            this.customerLevelData = data;
          }
        }
      };

      for (const key in ruleMap) {
        const {codes, fn} = ruleMap[key];
        if (ruleCodes.some(code => codes.includes(code))) {
          await fn();
        }
      }
    },
    // 新增、编辑规则配置
    addRuleConfigBtn(type, row) {
      let obj = {
        editType: type,
        configValue: this.configValue,
        configStatus: this.configStatus,
        ...row
      }
      this.$refs['ruleTemp'].open(obj);
    },
    // 选取状态
    selectStatus(index, value) {
      let v = this;
      v.pageParam.status = value;
      v.statusList.forEach((n, i) => {
        n.selected = i === index;
      });
    },
    // 优先级拖拽排序
    dragDrop(a, b) {
      this.tableSort(this.tableData[a].autoRuleId, b, a);
    },
    // 处理拖拽排序
    tableSort(autoRuleId, index, oldIndex) {
      let v = this;
      let obj = {
        currentId: autoRuleId, // 规则ID
        previousId: index ? v.tableData[index].autoRuleId : null, // 前一个
        businessId: v.tableData[oldIndex].businessId
      };
      if (!index && v.tableData.length > 1) {
        obj.nextId = v.tableData[0].autoRuleId;
      }
      if (oldIndex > index) {
        obj = {
          currentId: v.tableData[oldIndex].autoRuleId, // 规则ID
          businessId: v.tableData[oldIndex].businessId,
          previousId: index > 0 ? v.tableData[index - 1].autoRuleId : null
        };
        if (index >= 0 && index !== v.tableData.length - 1) {
          obj.nextId = v.tableData[index + 1].autoRuleId;
        }
      } else {
        obj = {
          currentId: v.tableData[oldIndex].autoRuleId, // 规则ID
          businessId: v.tableData[oldIndex].businessId,
          previousId: index > 0 ? v.tableData[index].autoRuleId : null
        };
        if (index >= 0 && index !== v.tableData.length - 1) {
          obj.nextId = v.tableData[index + 1].autoRuleId;
        }
      }
      let url = '';
      if (['ymsProductPriceCommonRule', 'ymsProductPriceMerchantRule'].includes(v.ymsRuleType)) {
        url = api.put_ymsProductPriceRule_updatePriority;
        obj.ymsRuleType = v.ymsRuleType;
      } else {
        url = api.put_ymsProductPriceServiceRule_updatePriority;
        obj.ymsRuleType = v.ymsRuleType;
      }
      v.axios.put(url, JSON.stringify(obj), {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.getList();
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
        }
      });
    },
    // 启用  停用规则
    enableDisableBtn(autoRuleId, type) {
      let v = this;
      const configMap = {
        enable: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003567'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003568'),
          successText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002485'),
          url: v.configStatus === '1' ? api.put_ymsProductPriceRule_enable + autoRuleId : api.put_ymsProductPriceServiceRule_enable + autoRuleId,
        },
        disable: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002470'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003569'),
          successText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002486'),
          url: v.configStatus === '1' ? api.put_ymsProductPriceRule_disable + autoRuleId : api.put_ymsProductPriceServiceRule_disable + autoRuleId,
        }
      };
      const config = configMap[type];
      if (config) {
        let {title, content, successText, url} = config;
        v.$Modal.confirm({
          title: title,
          content: content,
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000543'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            v.axios.put(url, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.search();
                v.$Message.success(successText);
              }
            });
          }
        });
      }
    },
    // 删除规则
    deleteRuleBtn(autoRuleId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002162'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003570'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000543'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          let url = v.configStatus === '1' ? api.delete_ymsProductPriceRule : api.delete_ymsProductPriceServiceRule;
          v.axios.delete(url + autoRuleId, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.search();
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000779'));
            }
          });
        }
      });
    },

    // 处理配置规则内容
    processConfigurationRuleContent(obj) {
      let newList = [];
      const rulesList = obj.rules || []; // 规则项
      const ruleItemsList = obj.ruleItems || []; // 选中的规则
      const ruleActions = obj.ruleActions || [];

      ruleItemsList.forEach(item => {
        const paramsArr = item?.ruleItemParams || [];
        const valueMap = {};
        paramsArr.forEach(param => {
          const key = param?.name;
          const values = (param?.ruleItemParamValues || [])
            .map(v => v?.value)
            .filter(v => v !== undefined && v !== null);
          if (key) valueMap[key] = values;
        });

        item.selectValueMap = valueMap;
      });

      ruleItemsList.forEach(item => {
        const ruleDef = rulesList.find(ele => ele.id === item.ruleCode);
        if (ruleDef) {
          newList.push({
            id: ruleDef.id,
            content: ruleDef.display,
            selectValueMap: item.selectValueMap,
          });
        }
      });
      // 根据 ID 匹配不同基础数据进行内容替换
      let htmlList = [];
      newList.forEach(rule => {
        const {id, selectValueMap} = rule;
        // === 平台所有商品规则 ===
        if (['CORE-YPPCR-002', 'CORE-YPPMR-002', 'CORE-YPPSCR-002', 'CORE-YPPSMR-002'].includes(id)) {
          htmlList.unshift(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003571'));
        }
        // === 商品的SPU规则 ===
        if (['CORE-YPPCR-004', 'CORE-YPPMR-004', 'CORE-YPPSCR-004', 'CORE-YPPSMR-004'].includes(id)) {
          let ymsSpuList = selectValueMap.ymsSpuList || [];
          let values = this.sepCommasFn(ymsSpuList.join(), [',', '，', '\n']);
          htmlList.push(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003542')}<span class="themeColor cursor" data-copy="${values.join('、')}">${values.join('、')}</span>`);
        }
        // === 商品的SKU规则 ===
        if (['CORE-YPPCR-006', 'CORE-YPPMR-008', 'CORE-YPPSCR-006', 'CORE-YPPSMR-008'].includes(id)) {
          let ymsSkuList = selectValueMap.ymsSkuList || [];
          let values = this.sepCommasFn(ymsSkuList.join(), [',', '，', '\n']);
          htmlList.push(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003543')}<span class="themeColor cursor" data-copy="${values.join('、')}">${values.join('、')}</span>`);
        }
        // === 分类规则 ===
        if (['CORE-YPPCR-001', 'CORE-YPPMR-001', 'CORE-YPPSCR-001', 'CORE-YPPSMR-001'].includes(id)) {
          let nameList = [];
          let ymsProductCategoryIds = selectValueMap.productCategories || [];
          this.categoricalData.forEach((item) => {
            if (ymsProductCategoryIds.includes(item.ymsProductCategoryId)) {
              nameList.push(item.name);
            }
          });
          htmlList.push(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003544')}<span class="themeColor cursor" data-copy="${nameList.join('、')}">${nameList.join('、')}</span>`);
        }
        // === 发货地/发货仓规则 ===
        if (['CORE-YPPCR-003', 'CORE-YPPMR-003', 'CORE-YPPSCR-003', 'CORE-YPPSMR-003'].includes(id)) {
          let deliveryNames = [];
          let warehouseNames = [];
          let ymsDeliveryPlaceIds = selectValueMap.ymsDeliveryPlaceIds || [];
          let ymsWarehouseIds = selectValueMap.ymsWarehouseIds || [];
          this.deliveryLocationData.forEach(item => {
            if (ymsDeliveryPlaceIds.includes(item.ymsDeliveryPlaceId)) {
              deliveryNames.push(item.deliveryPlaceName);
            }
          });
          this.shippingWarehouseData.forEach(item => {
            if (ymsWarehouseIds.includes(item.ymsWarehouseId)) {
              warehouseNames.push(item.name);
            }
          });
          if (deliveryNames.length > 0 && warehouseNames.length > 0) {
            htmlList.push(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003545')}<span class="themeColor cursor" data-copy="${deliveryNames.join('、')}">${deliveryNames.join('、')}</span>${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003546')}<span class="themeColor cursor" data-copy="${warehouseNames.join('、')}">${warehouseNames.join('、')}</span>`);
          } else {
            if (deliveryNames.length > 0) {
              htmlList.push(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003545')}<span class="themeColor cursor" data-copy="${deliveryNames.join('、')}">${deliveryNames.join('、')}</span>`);
            }
            if (warehouseNames.length > 0) {
              htmlList.push(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003547')}<span class="themeColor cursor" data-copy="${warehouseNames.join('、')}">${warehouseNames.join('、')}</span>`);
            }
          }
        }
        // === 供应商规则 ===
        if (['CORE-YPPCR-005', 'CORE-YPPMR-005', 'CORE-YPPSCR-005', 'CORE-YPPSMR-005'].includes(id)) {
          let supplierMerchantIds = selectValueMap.supplierMerchantIds || [];
          let values = this.sepCommasFn(supplierMerchantIds.join(), [',', '，', '\n']);
          htmlList.push(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003548')}<span class="themeColor cursor" data-copy="${values.join('、')}">${values.join('、')}</span>`);
        }
        // === 客户等级规则 ===
        if (['CORE-YPPMR-007', 'CORE-YPPSMR-007'].includes(id)) {
          let customerLevelIds = selectValueMap.distributorMerchantGradeList || [];
          let customerLevelNames = [];
          customerLevelIds.forEach(id => {
            const level = this.customerLevelData.find(item => item.ymsDistributorMerchantGradeId === id);
            if (level) customerLevelNames.push(level.name);
          });
          htmlList.push(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003549')}<span class="themeColor cursor" data-copy="${customerLevelNames.join('、')}">${customerLevelNames.join('、')}</span>`);
        }
        // === 分销商规则 ===
        if (['CORE-YPPMR-006', 'CORE-YPPSMR-006'].includes(id)) {
          let distributorMerchantIdList = selectValueMap.distributorMerchantIdList || [];
          let values = this.sepCommasFn(distributorMerchantIdList.join(), [',', '，', '\n']);
          htmlList.push(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003550')}<span class="themeColor cursor" data-copy="${values.join('、')}">${values.join('、')}</span>`);
        }
      });
      if (ruleActions.length > 0) {
        const list = JSON.parse(ruleActions[0].value) || [];
        let percentageValue = 0;
        let fixedAmount = 0;
        let wholesalePercentageValue = null;
        let wholesaleFixedAmount = null;
        let currency = this.currencyState;

        list.forEach(item => {
          const val = amountHandel(item.floatNum);
          if (item.floatType === 1) percentageValue = `${val}%`;
          if (item.floatType === 3) { // 1 销售价上浮 2 销售价下浮 3 销售价加价 4 销售价减价 5 批发价上浮 6 批发价下浮 7 批发价加价 8 批发价减价
            fixedAmount = val;
            currency = item.currency;
          }
          if (item.floatType === 5) wholesalePercentageValue = `${val}%`;
          if (item.floatType === 7) {
            wholesaleFixedAmount = val;
            currency = item.currency;
          }
        });

        const isAddPrice = this.configStatus === '1';
        const retailTitle = isAddPrice ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003572') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003573');
        const wholesaleTitle = isAddPrice ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003574') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003575');
        const baseText = isAddPrice ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003576') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003577');

        const makeLine = (title, p, f) =>
          `${title} = ${baseText}<span class="themeColor ml3 mr3">${p}</span> + ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000980')} <span class="themeColor ml2 mr2">${f} ${currency}</span>`;

        if (this.showProductWholesaleModel) {
          if (wholesalePercentageValue === null && wholesaleFixedAmount === null) {
            wholesalePercentageValue = JSON.parse(JSON.stringify(percentageValue));
            wholesaleFixedAmount = JSON.parse(JSON.stringify(fixedAmount));
          }
          htmlList.push(
            makeLine(retailTitle, percentageValue, fixedAmount),
            makeLine(wholesaleTitle, wholesalePercentageValue, wholesaleFixedAmount)
          );
        } else {
          const singleTitle = isAddPrice ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003578') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003579');
          htmlList.push(makeLine(singleTitle, percentageValue, fixedAmount));
        }
      }
      // 返回最终处理好的 HTML 拼接结果
      return htmlList.map((r, index) => `<p class="text-align-left">${r + (index !== htmlList.length - 1 ? '，' : '；')}</p>`).join('');
    },
    // 获取规则任务信息
    getRuleTaskInfo() {
      let taskStatus = '';
      this.ruleTaskProgress = toPercent(0, 2);
      this.axios.get(api.get_productInfo_getPriceAutoRule).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let isEnabled = data.isEnabled;
            let extendConfig = data.extendConfig;
            // 进度
            if (extendConfig) {
              let obj = JSON.parse(extendConfig);
              let num = Number(obj.curCount) / Number(obj.totalCount);
              this.ruleTaskProgress = toPercent(num, 2);
              if (Number(obj.curCount) !== Number(obj.totalCount) && obj.nestToken !== null) {
                taskStatus = 'processing';
              }
            }
            // 状态
            if (isEnabled === 0) {
              this.taskStatus = 'error';
            } else {
              switch (data.taskStatus) {
                case 2:
                  this.taskStatus = 'processing';
                  break;
                case 3:
                  this.taskStatus = 'success';
                  break;
                case 4:
                  if (taskStatus) {
                    this.taskStatus = taskStatus;
                  } else {
                    this.taskStatus = 'error';
                  }
                  break;
              }
            }
            // 时间
            this.lastSuccessDate = this.$uDate.dealTime(data.lastSuccessDate, 'fulltime') || '-';
          }
        }
      })
    },
    // 规则执行
    ruleEnforcementBtn() {
      let v = this;
      let content = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003551')}
                    <span class="themeColor">${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003552')}</span>${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003553')}`;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003580'),
        content: content,
        width: 500,
        dangerouslyUseHTMLString: true,
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.ruleTaskProgress = toPercent(0, 2);
          v.axios.get(api.get_productInfo_startPriceAutoRule).then(response => {
            if (response.data.code === 0) {
              v.taskStatus = 'processing';
            }
          });
        },
        onCancel: () => {

        }
      });
    },
    // 停止规则任务
    stopTheTaskBtn() {
      let v = this;
      v.axios.get(api.get_productInfo_stopPriceAutoRule).then(response => {
        if (response.data.code === 0) {
          v.taskStatus = 'error';
          setTimeout(() => {
            v.getRuleTaskInfo();
          }, 800);
        }
      });
    },
    /**
     * 注册销售价规则任务同步状态使用的 websocket 监听。
     */
    initWebSocket() {
      let v = this;
      if (!v.$webSocket.initWebSocket()) {
        return;
      }
      v.webSocketListenerKey = `product-sales-price-config-${v._uid}`;
      v.$webSocket.subscribeMessage(v.webSocketListenerKey, (e) => {
        const data = v.$webSocket.parseMessage(e);
        if (data) {
          let taskStatus = '';
          if (data.type === 'sync' && v.system === 'yms') {
            let obj = data.data;
            if (obj) {
              let extendConfig = obj.extendConfig || '';
              let isEnabled = obj.isEnabled;
              // 进度
              if (extendConfig) {
                let obj = JSON.parse(extendConfig);
                let num = Number(obj.curCount) / Number(obj.totalCount);
                v.ruleTaskProgress = toPercent(num, 2);
                if (Number(obj.curCount) !== Number(obj.totalCount) && obj.nestToken !== null) {
                  taskStatus = 'processing';
                }
              }
              // 状态
              if (isEnabled === 0) {
                v.taskStatus = 'error';
              } else {
                switch (obj.taskStatus) {
                  case 2:
                    v.taskStatus = 'processing';
                    break;
                  case 3:
                    v.taskStatus = 'success';
                    v.getRuleTaskInfo();
                    break;
                  case 4:
                    if (taskStatus) {
                      v.taskStatus = taskStatus;
                    } else {
                      v.taskStatus = 'error';
                    }
                    break;
                }
              }
            }
}
        }
      }, v);
    },

    /**
     * 清理销售价规则任务监听。
     */
    clearWebSocketListener() {
      if (!this.webSocketListenerKey) return;
      this.$webSocket.unsubscribeMessage(this.webSocketListenerKey);
      this.webSocketListenerKey = '';
    },
    // 处理配置规则可复制
    handleInnerHtmlCopy(event) {
      if (event.target) {
        let content = event.target.dataset.copy;
        if (content) {
          commonCopyContent(content, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001286'));
        }
      }
    }
  },
  components: {
    ruleTemp
  }
};
</script>

<style lang="less" scoped>
.container_box {
  .config_box {
    border: 1px solid #71B4FA;
    border-radius: 4px;
    overflow: hidden;
    padding: 8px;
    background-color: #F5FAFF;
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    font-size: 14px;
  }

  .modify_styles {
    /deep/ span {
      display: flex;
      align-items: center;
    }
  }

  .help_icon {
    margin-right: 5px;
    font-size: 20px;
    color: #fff;
    cursor: pointer;
  }
}
</style>
